export const Form = [
  {
    path: '/freeform/:app_module_id',
    name: 'freeform.index',
    component: () => import('@/pages/Form/FormModule')
  }
]
